<div class="footer-unsecure">
  <div>
    <span class="footer-unsecure-cc">
      &copy; {{ currentYear }}
      {{ 'imperonateTool.copyRight' | translate }}
    </span>
    <span class="footer-unsecure-pp-ll">
      <a
        target="_blank"
        href="https://www.cigna.com/legal/compliance/privacy-notices"
      >
        {{ 'imperonateTool.privacy' | translate }}
        <cigna-icon
          type="external-link"
          class="cg-mat-icon-link-right cg-color-digital-blue f-s-m"
        ></cigna-icon>
      </a>
    </span>
    <span class="footer-unsecure-pp-ll footer-unsecure-pp-ll-divider">
      <a
        target="_blank"
        [href]="'https://www.cigna.com/legal/compliance/disclaimers'"
      >
        {{ 'imperonateTool.legalDisclaimer' | translate }}
        <cigna-icon
          type="external-link"
          class="cg-mat-icon-link-right cg-color-digital-blue f-s-m"
        ></cigna-icon>
      </a>
    </span>
    <span class="footer-unsecure-pp-ll footer-unsecure-cookie">
      <!-- OneTrust Cookies Settings button start -->
      <a id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</a>
      <!-- OneTrust Cookies Settings button end -->
    </span>
  </div>
</div>
